<template>
  <div class="DACMain">
    <!-- <div class="DAC-left-container">
      <Dropdown placeholder="Document Type" />
    </div>
    <div class="DAC-right-container">
      <div class="right-top-container">

      </div>
    </div> -->
    <div class="DAC-Left">
      <div class="Left-Top">
        <p>Submit Document for Approval</p>
        <Dropdown placeholder="Document Type" :items="docType" itemKey="table" :selectedObject.sync="selectedDoctype" isRequired="true" />
        <Dropdown placeholder="Limit" :items="topList" itemKey="top" :selectedObject.sync="selectedTop" />
        <div class="creation-date">
          <div class="creation-date-text">Creation Date</div> 
          <DateTimePicker class="dtpicker" placeholder="Start" :showTime="false" :value.sync="selectedStartDate" />
          <DateTimePicker class="dtpicker" placeholder="End" :showTime="false" :value.sync="selectedEndDate" />
        </div>
        <div class="show-submitted">
          <CheckBox title="Show Submitted Document" :isChecked.sync="showcreated" />
          <img src="https://dsmlib.logistics.systems/Icons/SubmitDocument.png" alt="Submitted">
        </div>
        <br/>
        <button title="Refresh" @click="refreshClicked">Refresh</button>
      </div>
      <div class="Left-Bottom">
        <div class="Approver-Text">Assigned Approver</div>
        <div class="Approver-Dropdown">
            <div v-for="(data, index) in daSettings" :key="index">
              <!-- <Dropdown :placeholder="`Level ${data['APLevel']} Approver`" :items="data['UserList']" itemKey="UserID" :selectedObject.sync="data['selectedApprover']" isRequired="true" :isDisabled="data['EndLevel'] ? data['EndLevel'].trim() != '1' ? 'true' : 'true' : 'true'" /> -->
              <Dropdown class="Dropdown-Loop" :placeholder="`Level ${data['APLevel']} Approver`" :items="data['UserList']" itemKey="dropdownkey" :selectedObject.sync="data['selectedApprover']" :isDisabled="data['disabled']" />
            </div>
          </div>
      </div>
    </div>
    <div class="DAC-Right">
      <div class="Right-Top">
        <div class="Top-Left">
          <div class="Top-details"><div class="caption">Document Type</div>:{{refreshDocType}}</div>
          <div class="Top-details"><div class="caption">Start Date</div>:{{refreshStartDate}}</div>
          <div class="Top-details"><div class="caption">End Date</div>:{{refreshEndDate}}</div>
        </div>
        <div class="Top-Right">
          <!-- <div class="Top-details-refresh-date"><div class="right-caption">Time Refresh</div>:{{refreshTime}}</div> -->
          <div class="Top-details-refresh-date">Time Refresh<div>:</div><div class="right-value">{{refreshTime}}</div></div>
          <div class="Top-details-refresh-date">Limit<div>:</div><div class="right-value">{{refreshLimit}}</div></div>
          <div class="Top-details-refresh-date">Show Submitted<div>:</div><div class="right-value">{{refreshShowSubmitted}}</div></div>
          <!-- <div class="Top-details-refresh-date"><div class="right-caption">Limit</div>:{{selectedTop['Top']}}</div> -->
        </div>
      </div>
      <div class="Right-Mid">
        <TableBox :tableData="daCreatorList" title="Document List" :selectedRow.sync="selectedDocument" maxSelection="-1" :hideColumns="hideColumns" :dataType="{'Total Amount': 'number', 'Date Issued': 'date'}" :additionalIconsIndex="iconsIndex" />
      </div>
      <div class="Right-Bottom">
        <div class="Bottom-Messagebox" ref="msgbox"></div>
        <button title="Submit" @click="submitClicked" :disabled="selectedDocument.length == 0 ? true : false">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {
      //document type filter
      docType: [],
      selectedDoctype: null,

      // //issued to filter
      // issuedTo = [],
      // selectedIssuedTo = null,

      // //amount filter
      // amount = null,
      topList: [ {'top': '50'},{'top': '100'},{'top': '500'},{'top': 'ALL'} ],
      selectedTop: null,
      showcreated: false,

      selectedStartDate: null,
      selectedEndDate: null,

      //table data
      daCreatorList: [],
      selectedDocument: [],
      hideColumns: ['AdditionalDetails', 'Created'],
      iconsIndex: [0],
      daSettings: [],

      refreshTime: null,
      refreshDocType: '',
      refreshStartDate: null,
      refreshEndDate: null,
      refreshLimit: null,
      refreshShowSubmitted: '',
    }
  },
  methods: {
    callAPI: async function() {
      this.$fullscreenLoading('Getting Details');
    },

    refreshClicked: async function() {
      this.$fullscreenLoading('Getting Documents');
      this.refreshTime = new Date().formatString('yyyy-MM-dd HH:mm:ss');
      this.refreshDocType = this.selectedDoctype ? this.selectedDoctype['table'] : '';
      this.refreshStartDate = this.selectedStartDate ? this.selectedStartDate.formatString('yyyy-MM-dd') : '';
      this.refreshEndDate = this.selectedEndDate ? this.selectedEndDate.formatString('yyyy-MM-dd') : '';
      this.refreshLimit = this.selectedTop ? this.selectedTop['top'] : '';
      this.refreshShowSubmitted = this.showcreated == true ? 'Yes' : 'No'
      this.daCreatorList = [];
      this.selectedDocument = [];

      var postData_daCreatorListTemp = {
        'action': '',
        'table': this.selectedDoctype ? this.selectedDoctype['table'] : '',
        // 'startdate': this.selectedStartDate ? this.selectedStartDate.formatString('yyyy-MM-dd') : '2018-01-01',
        'startdate': this.selectedStartDate ? this.selectedStartDate.formatString('yyyy-MM-dd') : '2010-01-01',
        'enddate': this.selectedEndDate ? this.selectedEndDate.formatString('yyyy-MM-dd') : '',
        'showcreated': this.showcreated == true ? '1' : '0',
        'top': this.selectedTop ? this.selectedTop['top'] : ''
      }
      // console.log(postData);

      let daCreatorListTemp = await this.$apiCallV2('/DocumentApprovalCreator/DocApprovalCreator', postData_daCreatorListTemp);
      if (daCreatorListTemp) {
        console.log(daCreatorListTemp);
        console.log(Array.isArray(daCreatorListTemp));
        // if (Array.isArray(daCreatorListTemp)) {
        //   this.$showAlert('info', 'Page Block', daCreatorListTemp[0]['ErrMsg']);
        // } else {
          if (daCreatorListTemp['Document']) {
            this.daCreatorList = daCreatorListTemp['Document']['DocList'].map(a => {
              return {
                "":a['Created'] ? a['Created'] == '1' ? 'https://dsmlib.logistics.systems/Icons/SubmitDocument.png' : '' : '',
                ...a
              }
            });
          }
        // }
      }
      console.log(this.daCreatorList);

      var postData_daSettingsTemp = {
        'table': this.selectedDoctype ? this.selectedDoctype['table'] : ''
      }

      let daSettingsTemp = await this.$apiCallV2('/DocumentApprovalCreator/DocumentApprovalSettings', postData_daSettingsTemp)
      if (daSettingsTemp) {
        console.log(this.daSettings);
        this.daSettings = daSettingsTemp['DASTable']['TableList'].map(a => {
          let obj = a;
          obj['selectedApprover'] = null;
          obj['disabled'] = a['EndLevel'] ? a['EndLevel'] != '1' : false;
          let any_all = {
            "APLevel":a["APLevel"],
            "EndLevel":a["EndLevel"],
            "Table":a["Table"],
            "UserID":"ALL",
            "UserName":"ANYONE"
          }
          obj['UserList'].push(any_all);
          console.log(obj['UserList']);
          obj['UserList'].map(b => {
            let obj2 = b;
            obj2['dropdownkey'] = `${b['UserName']} - ${b['UserID']}`;
            return obj2;
          });
          obj['selectedApprover'] = any_all;
          return obj;
        });
        // let defaultSelectedApprover = this.daSettings['DASTable']['TableList']['UserList'].filter(b => b['UserID'].trim() == "ALL");
        // console.log(defaultSelectedApprover);
        // this.daSettings['DASTable']['TableList']['selectedApprover'] = 
        console.log(this.daSettings);
      }
      console.log(this.daSettings);
      // this.loading = false;
      this.$fullscreenLoading('');
    },

    submitClicked: async function() {
      this.$fullscreenLoading('Submitting Documents');
      console.log(this.selectedDocument);

      this.selectedDocument.forEach(async a => {
        var postData_submit = {
          action: a['Created'] ? a['Created'] == '1' ? 'E' : 'N' : 'N',
          table: this.selectedDoctype ? this.selectedDoctype['table'] : '',
          docno: a['Document No'],
          required: this.daSettings.map(a => a['selectedApprover'] ? `${a['APLevel']}:${a['selectedApprover']['UserID']}` : `${a['APLevel']}:ALL`).join(';')
        };
        console.log(postData_submit);
        let submitResult = await this.$apiCallV2('/DocumentApprovalCreator/DocApprovalCreator', postData_submit);
        if (submitResult) {
          console.log(submitResult);
          if (submitResult['Results'] != '0') {
            console.log('success');
          }
        }
      });

      this.$fullscreenLoading('');
      this.refreshClicked();
    }
  },
  async mounted() {
    this.$fullscreenLoading('Getting Details');

    //get the documen table required by company
    let docArray = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DOCUMENTAPPROVAL_TABLE' });
    console.log(docArray);
    if (docArray.length > 0) {
      console.log('testing 1');
      let docTypeArrayString = JSON.parse(docArray[0]['addinfojson'])['DocApproval'];
  
      //convert string array to object with key value
      this.docType = docTypeArrayString.map(a => {
        return {table: a};
      })
    } else {
      this.$showAlert('error', 'Missing Details', 'Company Settings not completely setup. ');
    }

    //get the table parameter from url
    let query = this.$route.query;
    if (query['table']) {
      //match the parameter value to doctype object value
      this.selectedDoctype = this.docType.getSelected(query['table'], 'table');
    }

    //set default value
    this.selectedTop = this.topList.getSelected('500', 'top');

    this.refreshClicked();
    this.$fullscreenLoading('');
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.DACMain {
  font-size: 12px;
  padding: 5px 45px;
  display: flex;
  flex-direction: row;

  > .DAC-Left {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    margin-right: 5px;
    max-width: 250px;
    min-width: 250px;

    > .Left-Top {
      > .creation-date {
        border: 1px solid black;
        border-radius: 5px;
        
        margin-top: 10px;
        position: relative;
  
        > .creation-date-text {
          top: -10px;
          position: absolute;
          background-color: white;
          padding: 0 10px;
          left: 10px;
        }

        > .dtpicker {
          padding: 5px;
          margin: 5px;
        }
      }

      > .show-submitted {
        margin-top: 5px;
        position: relative;

        img {
          width: 20px;
          height: 20px;
          position: absolute;
          right: 30px;
          top: 0px;
        }
      }

      Button {
        width: 100%;
      }
    }

    > .Left-Bottom {
      margin-top: 50px;
      border: 1px solid black;
      border-radius: 5px;
      // padding: 5px;
      // margin: 5px;
      position: relative;

      > .Approver-Text {
        top: -10px;
        position: absolute;
        background-color: white;
        padding: 0 10px;
        left: 10px;
      }

      > .Approver-Dropdown {
        padding: 5px;
        margin: 5px;
      }
    }
  }

  > .DAC-Right {
    display: flex;
    flex-direction: column;
    width: calc(100% - 250px);

    > .Right-Top {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      margin-bottom: 5px;
      display: flex;
      flex-direction: row;
      height: 60px;

      > .Top-Left {
        width: 50%;

        > .Top-details {
          display: flex;
          align-items: center;

          > .caption {
            min-width: 110px;
            max-width: 110px;
          }
        }
      }
      
      > .Top-Right {
        width: 50%;

        > .Top-details-refresh-date {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          > .right-value {
            text-align: right;
            min-width: 150px;
            max-width: 150px;
          }
        }
      }
    }

    > .Right-Mid {
      height: calc(100% - 120px) ;
    }

    > .Right-Bottom {
      background-color: white;
      padding: 5px;
      border-radius: 5px;
      height: 60px;
      display: flex;
      flex-direction: row;
      

      > .Bottom-Messagebox {
        flex-grow: 1;
        background-color: rgba(255, 246, 121, 0.37);
        overflow: auto;
        height: 100%;
        width: 80%;
        white-space: pre-wrap;
      }
    }
  }
}
</style>